import { RefreshCw, TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { isUpdateError, reloadForUpdate } from '@/lib/app-update';
import { Button } from './ui';

/**
 * What staff see when a page fails, in place of the router's developer message (owner, 2026-10-16). A page left open
 * across an update reloads itself; anything else says what to do, and that nothing already saved is lost.
 */
export function RouteError() {
  const error = useRouteError();
  const update = isUpdateError(error);
  useEffect(() => {
    console.error(error);
    if (update) reloadForUpdate();
  }, [error, update]);
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div className="card mx-auto mt-16 max-w-md p-8 text-center">
      {update ? <RefreshCw className="mx-auto mb-3 size-8 text-brand-600" /> : <TriangleAlert className="mx-auto mb-3 size-8 text-amber-500" />}
      <h1 className="font-semibold">{update ? 'The system has just been updated' : notFound ? 'Page not found' : 'This page could not open'}</h1>
      <p className="mt-2 text-sm text-slate-600">
        {update
          ? 'Reload to open the new version. Nothing you saved is lost.'
          : notFound
            ? 'The link may be old. Go back to the home page.'
            : 'Reload the page. If it happens again, tell IT what you were doing and the time; nothing you already saved is lost.'}
      </p>
      <div className="mt-5 flex justify-center gap-2">
        <Button variant="primary" icon={<RefreshCw className="size-4" />} onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Button onClick={() => window.location.assign('/')}>Home</Button>
      </div>
    </div>
  );
}
